var baoli = {
  "app_id": 207946,
  "AppId": ""
}

export default baoli;